import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../contexts/GlobalContext';
import axios from '../utils/axiosConfig';

const OnboardingModal = () => {
  const navigate = useNavigate();
  const { setHasOnboarded, setUserProfile } = useContext(GlobalContext);
  const [experienceRatings, setExperienceRatings] = useState({
    grad_year: 5,
    recruiting_experience: 5,
  });
  const currentYear = new Date().getFullYear();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const experienceTypes = [
    {
      key: 'grad_year',
      label: 'I graduate in...',
      levels: [
        { value: 1, label: `${currentYear}` },
        { value: 2, label: `${currentYear + 1}` },
        { value: 3, label: `${currentYear + 2}` },
        { value: 4, label: `${currentYear + 3}` },
        { value: 5, label: 'None applies for me' },
      ],
    },
    {
      key: 'recruiting_experience',
      label: 'My experience with software engineering recruiting is...',
      levels: [
        { value: 1, label: "I don't know anything about it" },
        { value: 2, label: "I've started but still learning" },
        { value: 3, label: 'I understand the process and have applied' },
        { value: 4, label: 'I have gotten interviews already' },
        { value: 5, label: "I'm quite confident in the process" },
      ],
    },
  ];

  const handleRatingChange = (experienceType, value) => {
    setExperienceRatings((prev) => ({
      ...prev,
      [experienceType]: parseInt(value),
    }));
  };

  const submitExperience = async () => {
    try {
      const userID = localStorage.getItem('userID');
      await axios.put(`/api/v1/user/experience/${userID}`, {
        experience: {
          grad_year: experienceRatings.grad_year,
          recruiting_experience: experienceRatings.recruiting_experience,
        },
        has_onboarded: 'true',
      });

      setHasOnboarded(true);

      const userResponse = await axios.get(`/api/v1/user/${userID}`);
      const data = userResponse.data;
      if (data.user) {
        data.user.has_onboarded = true;
        setUserProfile(data.user);
        setHasOnboarded(true);
        navigate('/progress-tree');
      }
    } catch (error) {
      console.error('Error updating experience:', error);
    }
  };

  return (
    <div className="fixed inset-0 z-60 overflow-y-auto">
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-black/70 transition-opacity"></div>

        {/* Modal */}
        <div className="relative transform overflow-hidden rounded-xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">
          <div className="flex justify-between items-center p-6 border-b">
            <h2 className="text-xl font-semibold">Two more questions, we promise</h2>
          </div>

          <div className="p-6">
            <div className="space-y-4">
              {experienceTypes.map((experience) => (
                <div key={experience.key} className="">
                  <h3 className="text-sm font-medium text-gray-800 mb-2">{experience.label}</h3>
                  <select
                    value={experienceRatings[experience.key]}
                    onChange={(e) => handleRatingChange(experience.key, parseInt(e.target.value))}
                    className="w-full p-2 text-sm border border-gray-200 rounded-md bg-white focus:outline-hidden focus:ring-2 focus:ring-blue-500"
                  >
                    {experience.levels.map((level) => (
                      <option key={level.value} value={level.value}>
                        {level.label}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
            </div>
          </div>

          <div className="border-t p-6 flex justify-end">
            <button
              onClick={submitExperience}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-xs text-white bg-blue-600 hover:bg-blue-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Let's go!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingModal;
